import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconConsoleSimple1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconConsoleSimple1"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H3V3ZM7.25 6.68934L10.0607 9.5L7.25 12.3107L6.18934 11.25L7.93934 9.5L6.18934 7.75L7.25 6.68934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconConsoleSimple1;
